import { ENDPOINTS } from "@/settings/api-settings";
import { AxiosResponse } from "axios";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";

export function listProductsAlertsPrescriptionsReport(): Observable<any> {
    return from(
        apiClient.get(ENDPOINTS.ALERTS_PRESCRIPTIONS_REPORT_PRODUCTS),
    ).pipe(map((r: any) => r.data || {}));
}

export function listCodesAlertsPrescriptionsReport(): Observable<any> {
    return from(
        apiClient.get(ENDPOINTS.ALERTS_PRESCRIPTIONS_REPORT_CODES),
    ).pipe(map((r: any) => r.data || {}));
}

export function listDataAlertsPrescriptionsReport(filters: any): Observable<any> {
    return from(
        apiClient.get(ENDPOINTS.ALERTS_PRESCRIPTIONS_REPORT, filters),
    ).pipe(map((r: any) => r.data || {}));
}

export function buildAlertsPrescriptionsXlsReport(filters: any): Observable<AxiosResponse> {
    return from(
        apiClient.download(ENDPOINTS.ALERTS_PRESCRIPTIONS_REPORT_XLS, filters),
    );
}

